import React from 'react'
import {components} from '../config/flavour'
import FooterComponent from './FooterComponent'
import {loadConfigurationFromOrigin} from '../configLoader'

export default function AboutPage() {
  loadConfigurationFromOrigin().then(() => {
    return (
      <>
        <components.AboutPageContent />
        <FooterComponent />
      </>
    )
  })
}
